//import { com as commonMp  } from "@rosetta/gaia-progress-common-mp";
import { com as progressMp } from '@rosetta/gaia-progress-mp';
//import { com as gaiaProgressDomain  } from "@rosetta/gaia-progress-domain-mp";

//$module$gaia_progress_mp_common_mp.com.rosettastone.Log;

var gpConfig = void 0;
var gpErrorHandler = void 0;
var gpGaiaApolloClient = void 0;
var gpLogger = void 0;
var gpAssignedCoursesAndProgressQuery = void 0;
var gpEnhanceProgressMessageWithAnalytics = void 0;
var gpUserAgent = void 0;
var gpReduxStore = void 0;
var gpCourseSelectors = void 0;
var gpStepModel = void 0;
var gpStepCardModel = void 0;
var gpPronunciationModel = void 0;

// Gaia-Progress user MUST invoke this method to provide to this NPM module all the resources it
// needs to work properly.
export var initializeGaiaProgress = function initializeGaiaProgress(_ref) {
  var config = _ref.config,
      errorHandler = _ref.errorHandler,
      gaiaApolloClient = _ref.gaiaApolloClient,
      logger = _ref.logger,
      assignedCoursesAndProgressQuery = _ref.assignedCoursesAndProgressQuery,
      enhanceProgressMessageWithAnalytics = _ref.enhanceProgressMessageWithAnalytics,
      userAgent = _ref.userAgent,
      reduxStore = _ref.reduxStore,
      courseSelectors = _ref.courseSelectors,
      stepModel = _ref.stepModel,
      stepCardModel = _ref.stepCardModel,
      pronunciationModel = _ref.pronunciationModel;

  gpConfig = config;
  gpErrorHandler = errorHandler;
  gpGaiaApolloClient = gaiaApolloClient;
  gpLogger = logger;
  gpAssignedCoursesAndProgressQuery = assignedCoursesAndProgressQuery;
  gpEnhanceProgressMessageWithAnalytics = enhanceProgressMessageWithAnalytics;
  gpUserAgent = userAgent;
  gpReduxStore = reduxStore;
  gpCourseSelectors = courseSelectors;
  gpStepModel = stepModel;
  gpStepCardModel = stepCardModel;
  gpPronunciationModel = pronunciationModel;

  //  const verbose = commonMp.rosettastone.LogLevel.VERBOSE;
  // progressMp.rosettastone.Log.Companion.setLogLevel(progressMp.rosettastone.LogLevel.VERBOSE);
  // progressMp.rosettastone.Log.Companion.v("Gaia-Progress", "Kotlin MP Logging Working");
};

export var getConfig = function getConfig() {
  return gpConfig;
};
export var getErrorHandler = function getErrorHandler() {
  return gpErrorHandler;
};
export var getGaiaApolloClient = function getGaiaApolloClient() {
  return gpGaiaApolloClient;
};
export var getLogger = function getLogger() {
  return gpLogger;
};
export var getUserAgent = function getUserAgent() {
  return gpUserAgent;
};
export var getReduxStore = function getReduxStore() {
  return gpReduxStore;
};

export var getCourseSelectors = function getCourseSelectors() {
  return gpCourseSelectors;
};
export var getStepModel = function getStepModel() {
  return gpStepModel;
};
export var getStepCardModel = function getStepCardModel() {
  return gpStepCardModel;
};
export var getPronunciationModel = function getPronunciationModel() {
  return gpPronunciationModel;
};
export var getAssignedCoursesAndProgressQuery = function getAssignedCoursesAndProgressQuery() {
  return gpAssignedCoursesAndProgressQuery;
};
export var enhanceProgressMessageWithAnalytics = function enhanceProgressMessageWithAnalytics(message) {
  return gpEnhanceProgressMessageWithAnalytics(message);
};